import { useRef, useEffect, useState } from 'react';
import { Tooltip } from 'antd';
import RewardsModal, { RewardsModalHandle } from '../RewardsModal';
import styled from './index.module.scss';
import BonusModal, { BonusModalHandle } from './BonusModal';
import Button from '@/components/UI/Button';
import { QuestionIcon2 } from '@/components/UI/svg/Referral';
import NextImage from '@/components/NextImage';
import { useReferralStore, useReferralDispatch } from '@/components/Referral/ReferralProvider';
import { useGlobal } from '@/utils/useGlobal';
import { formatPrice } from '@/components/Referral/util';
import { withdrawalWhiteLocale } from '@/constants/my';
import gtm from '@/utils/gtm';

const MyBonus = ({ onMyRewards }: any) => {
    const { useLang, useRouter, isMobile, Link } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('referral');
    const bonusRef = useRef<BonusModalHandle>(null);
    const rewardsRef = useRef<RewardsModalHandle>(null);
    const dispatch = useReferralDispatch();
    const { userPointsInfo, referralInfo, userWalletInfo, inBlackList } = useReferralStore();
    const [disabled, setDisabled] = useState(true);

    useEffect(() => {
        if (!referralInfo) return;
        dispatch({ type: 'getUserPointsInfo', payload: { locale, planId: referralInfo?.planId } });
        dispatch({ type: 'getUserWalletInfo', payload: { locale } });
    }, [referralInfo]);

    useEffect(() => {
        if (!userWalletInfo) return;
        if (userWalletInfo?.availableAmount >= userWalletInfo?.withdrawalMinAmount && !inBlackList) {
            setDisabled(false);
        }
    }, [userWalletInfo]);

    useEffect(() => {
        const handleStorageChange = (event: any) => {
            if (event.key === 'withdrawalrequest-close') {
                dispatch({ type: 'getUserWalletInfo', payload: { locale } });
            }
        };

        const detectCloseHandler = () => {
            window.addEventListener('storage', handleStorageChange, false);
        };

        detectCloseHandler();

        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);
    return (
        <div className={styled.my_bonus}>
            <div className="content">
                <NextImage
                    src={require(`@publicLocal/referral/${isMobile ? 'h5' : 'pc'}/mybonus.png`)}
                    alt={t('mybonus.rewards')}
                    aria-label={t('mybonus.rewards')}
                />
                <div className="rewards">
                    <div className="text">
                        <div className="ecocredits">
                            <p className="num">{userPointsInfo?.registerCount || 0}</p>
                            <p className="desc">{t('mybonus.ecoCredits1')}</p>
                        </div>
                        <div className="ecocredits">
                            <p className="num">{userPointsInfo?.purchaseCount || 0}</p>
                            <p className="desc">{t('mybonus.ecoCredits2')}</p>
                        </div>
                        {withdrawalWhiteLocale.includes(locale) && (
                            <div className="ecocredits">
                                <p className="num">{formatPrice(locale, userWalletInfo?.availableAmount || 0)}</p>
                                <p className="desc">
                                    {t('mybonus.ecoCredits3')}
                                    <Tooltip
                                        placement="top"
                                        trigger={['hover', 'click']}
                                        title={t('mybonus.ecoCredits3_tips', { code: formatPrice(locale, userWalletInfo?.withdrawalMinAmount || 0, false) })}
                                        color="#656565"
                                    >
                                        <QuestionIcon2 className="qus_icon" />
                                    </Tooltip>
                                </p>
                                {!disabled ? (
                                    <Button
                                        type="link"
                                        href={`/${locale}/withdrawal-request?redirect=${encodeURIComponent(location.href)}`}
                                        className={`link`}
                                        target={['br', 'mx'].includes('locale') ? '_self' : '_blank'}
                                    >
                                        {t('mybonus.ecoCredits3_btn')} &gt;
                                    </Button>
                                ) : (
                                    <span className="disabled link">{t('mybonus.ecoCredits3_btn')} &gt;</span>
                                )}
                            </div>
                        )}
                    </div>
                    <div className="btns">
                        <Button
                            className="refer-btn white"
                            onClick={() => {
                                rewardsRef.current?.show();
                                try {
                                    gtm.push({
                                        event: 'uaEvent',
                                        event_name: 'referral_button',
                                        position: referralInfo?.title || '',
                                        button_name: t('banner.btn2'),
                                    });
                                } catch (e) {
                                    console.log(e);
                                }
                            }}
                            aria-label={t('banner.btn2')}
                        >
                            {t('banner.btn2')}
                        </Button>
                        <Button
                            className="refer-btn white"
                            onClick={() => {
                                bonusRef.current?.show();
                                try {
                                    gtm.push({
                                        event: 'uaEvent',
                                        event_name: 'referral_button',
                                        position: referralInfo?.title || '',
                                        button_name: t('mybonus.btn'),
                                    });
                                } catch (e) {
                                    console.log(e);
                                }
                            }}
                            aria-label={t('mybonus.btn')}
                        >
                            {t('mybonus.btn')}
                        </Button>
                    </div>
                </div>
            </div>
            <BonusModal ref={bonusRef} planId={referralInfo?.planId} />
            <RewardsModal ref={rewardsRef} planId={referralInfo?.planId} />
        </div>
    );
};

export default MyBonus;
